export function getLanguageServerVersion(): string {
  return '6.7.1';
}
